import type { EspdResponseDto, EspdRequirementResponseDto } from "../../../../../autogen/bff-api";

export const emptyEspd = (): EspdResponseDto => ({
  specVersion: "EHF-ESPD-1.2",
  responses: [],
  economicOperator: { smeIndicator: null, representatives: [] },
  finalDeclaration: { confirmed: false },
});

export const espdAnswerFor = (espd: EspdResponseDto, requirementId: string): EspdRequirementResponseDto | undefined =>
  espd.responses?.find((r) => r.requirementId === requirementId);

export const setEspdAnswer = (
  espd: EspdResponseDto,
  requirementId: string,
  patch: Partial<EspdRequirementResponseDto>,
): EspdResponseDto => {
  const others = (espd.responses ?? []).filter((r) => r.requirementId !== requirementId);
  return { ...espd, responses: [...others, { requirementId, ...patch }] };
};

export const removeEspdAnswer = (
  espd: EspdResponseDto,
  requirementId: string,
): EspdResponseDto => ({
  ...espd,
  responses: (espd.responses ?? []).filter(
    (r) => r.requirementId !== requirementId,
  ),
});
